import React, { useState } from 'react';
import clsx from 'clsx';

export interface Tab {
  label: string;
  panel: React.ReactNode;
}

export interface TabsProps {
  tabs: Tab[];
  className?: string;
}

export const Tabs: React.FC<TabsProps> = ({ tabs, className }) => {
  const [activeTab, setActiveTab] = useState(tabs[0]?.label || '');

  return (
    <div className={clsx('w-full', className)}>
      {/* Tab bar */}
      <div className="flex border-b border-border relative">
        {tabs.map((tab) => (
          <button
            key={tab.label}
            onClick={() => setActiveTab(tab.label)}
            className={clsx(
              'px-4 py-3 text-sm font-medium transition-all duration-150 relative',
              activeTab === tab.label
                ? 'text-primary'
                : 'text-text-secondary hover:text-text-primary'
            )}
          >
            {tab.label}
            {activeTab === tab.label && (
              <span className="absolute bottom-0 left-0 right-0 h-0.5 bg-primary rounded-full" />
            )}
          </button>
        ))}
      </div>

      {/* Content panel */}
      <div className="pt-4 relative">
        {tabs.map((tab) => (
          <div
            key={tab.label}
            className={clsx(
              'transition-opacity duration-200',
              activeTab === tab.label ? 'opacity-100' : 'opacity-0 absolute inset-0 pointer-events-none'
            )}
          >
            {tab.panel}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Tabs;